import { combineReducers } from 'redux'

import categories from './categories'
import categorySelectionType from './categorySelectionType'

export default combineReducers({
  categories,
  categorySelectionType,
})
